import { Entity } from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useAsync } from 'react-use';

export const useAccountEntities = (
  accountIds: string[],
): { loading: boolean; entities: Entity[] } => {
  const catalogApi = useApi(catalogApiRef);

  const { loading, value: catalogResponse } = useAsync(() => {
    if (accountIds.length === 0) {
      return Promise.resolve({ items: [] });
    }
    return catalogApi.getEntities({
      filter: {
        kind: ['Resource'],
        'metadata.annotations.amazonaws.com/account-id': accountIds,
        'spec.type': 'account',
      },
    });
  }, [catalogApi, accountIds]);

  return { loading, entities: catalogResponse?.items ?? [] };
};
